import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class NoData extends Component {
    static propTypes = {
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    }

    render() {
        const { text } = this.props

        return <div className={'global-no-data-component'}>{text}</div>
    }
}
